import { allOptionsValue } from '~/constants/main';
import { localeStore } from '~/mobx/localesStore';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';

// export const findAllSelectedOption = ({ value }: { value: string }) => allOptionsValue === value;
export const findAllSelectedOption = (options: IPickerOption[]) => options.find(({ value }: { value: string }) => allOptionsValue === value);
export const skipAllSelectedOption = (options: IPickerOption[]) => options.filter(({ value }: { value: string }) => allOptionsValue !== value);

export const getFilterOptionsForPicker = ({ availableBranches, branches }: { availableBranches: IPickerOption[]; branches: IPickerOption[] }) => {
  const available = skipAllSelectedOption([...availableBranches]);
  available.sort((a, b) => {
    const aIsSelected = !!branches.find(({ value }) => value === a.value);
    const bIsSelected = !!branches.find(({ value }) => value === b.value);
    if (aIsSelected && bIsSelected) {
      return a.warringText ? 1 : b.warringText ? -1 : 0;
    }
    if (aIsSelected) return -1;
    if (bIsSelected) return 1;
    return 0;
  });
  return available.length ? [{ label: localeStore.t('reports_select_all_branches_dropdown'), value: allOptionsValue }, ...available] : [];
};
